import React, { useState, useMemo, useEffect } from "react";
// react plugin used to create DropdownMenu for selecting items
import Select from 'react-select'
import './SelectInstitution.css'

const SelectInstitution = (props) => {
  const [value, setValue] = useState()
  const [options, setOptions] = useState([])
  const device = props.device
  const setDevice = props.setDevice

  const changeHandler = item => {
    setValue(item)
    device['institution'] = item.value
    setDevice(device)
  }

  useEffect(() => {

    let alternatives = []

    props.selectOptions?.map((item) => {
      let target = { value: item._id, label: item.name }

      alternatives.push(target)

      if (item._id == props.institution)
        setValue(target)

    })

    setOptions(alternatives)

  }, [props.selectOptions])

  return (
    <div >
      <Select
        className="form-control-alternative"
        isDisabled={props.formDisabled}
        options={options}
        value={value}
        id="input-institution"
        classNamePrefix="selectInstitution"
        onChange={changeHandler}
      />
    </div>
  );

}

export default SelectInstitution;
